import { render, staticRenderFns } from "./CreateProjectDetailAssistant.vue?vue&type=template&id=02737e10&scoped=true&lang=pug&"
import script from "./CreateProjectDetailAssistant.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectDetailAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProjectDetailAssistant.vue?vue&type=style&index=0&id=02737e10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02737e10",
  null
  
)

export default component.exports